<template>
  <div class="content wrapper">
    <!-- <div class="header">
      {{ title }}
    </div> -->
    <list-loadding :showloadding="showloadding">
      <partner-list
        :title="item.menu.C_SUBJECT"
        :list="item.articles"
        v-for="(item, index) in list"
        :key="index"
        @listevent="listevent"
      >
      </partner-list>
    </list-loadding>
    <footerAct></footerAct>
  </div>
</template>
<script>
import { GetMenuAndArticleByPId } from "@/api/index";
import partnerList from "@/components/partner-list";
import listLoadding from "@/components/listLoadding";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      content: "",
      pid: 734,
      title: "合作伙伴",
      list: [],
      showloadding: false,
    };
  },
  computed: {
    ...mapGetters(["webSiteImageUrl"]),
  },
  components: { partnerList, listLoadding },

  created() {
    document.title = this.title;
    this.getListById(this.pid);
  },
  methods: {
    listevent(data, title) {
      console.log(data);
      let params = {
        id: data.N_ARTICLE_ID,
        title: title,
      };
      if (data.C_CONTENT) {
        this.$router.push({
          path: "partnerdetail",
          query: params,
        });
      }
    },
    getListById(id) {
      let $this = this;
      this.showloadding = true;
      GetMenuAndArticleByPId(id)
        .then((res) => {
          $this.showloadding = false;
          let list = res.list;
          if (list && list.length) {
            list.forEach((item) => {
              item.articles.forEach((a) => {
                a.C_LOGO = $this.webSiteImageUrl + a.C_LOGO;
              });
            });
          }
          $this.list = list;
          console.log(res);
        })
        .catch((err) => {
          $this.showloadding = false;
          console.log(err);
        });
    },
  },
};
</script>
<style lang="scss" scoped>

</style>